/**
 * Homeline mobile tab bar, Shop sheet and search (snippets/hl-tabbar.liquid).
 * Ports the springs from the handoff prototype (Scrollbar.dc.html):
 *
 *   k = (2π/response)², c = 4π·damping/response, 4 substeps per frame,
 *   always animating from the current on-screen value so input never locks.
 *
 * Home, Saved and Cart are navigations: the pill springs to the tab, then the
 * page changes. Shop opens the sheet. Only active ≤960px; on desktop the bar
 * is display: none and nothing here runs until the viewport crosses over.
 *
 * Other scripts talk to it through two document events:
 *   hl-tabbar:open-shop   → opens the Shop sheet (cart empty state uses it)
 *   hl-tabbar:state       ← fired with { searching, shopOpen } on every change
 */
(function () {
  if (window.__hlTabbarInit) return;
  window.__hlTabbarInit = true;

  var root = document.querySelector('[data-hl-tabbar]');
  if (!root) return;

  var mq = window.matchMedia('(max-width: 960px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TABS = ['home', 'shop', 'saved', 'cart'];
  var RECENT_KEY = 'hl_recent_searches_v1';
  var RECENT_DEFAULT = ['Modular sofa', 'Oak', 'Dining chairs'];

  var $ = function (sel) { return root.querySelector(sel); };
  var row = $('[data-tb-row]');
  var pill = $('[data-tb-pill]');
  var tabEls = Array.prototype.slice.call(root.querySelectorAll('.hl-tb__tab'));
  var sheet = $('[data-tb-sheet]');
  var sheetHead = $('[data-tb-sheet-head]');
  var scrim = $('[data-tb-scrim]');
  var tiles = Array.prototype.slice.call(sheet.querySelectorAll('[data-tile]'));
  var badge = $('[data-tb-badge]');
  var input = $('[data-tb-input]');
  var overlay = $('[data-tb-overlay]');

  document.body.classList.add('hl-tabbar-on');

  var active = root.dataset.active || '';
  var activeIndex = TABS.indexOf(active);

  function spring(pos, vel, target, resp, damp, dt) {
    var k = Math.pow((2 * Math.PI) / resp, 2);
    var c = (4 * Math.PI * damp) / resp;
    var h = dt / 4;
    for (var i = 0; i < 4; i++) {
      vel += (-k * (pos - target) - c * vel) * h;
      pos += vel * h;
    }
    return [pos, vel];
  }
  function rubber(o, d) { return (o * d * 0.55) / (d + 0.55 * Math.abs(o)); }
  function clamp01(n) { return Math.max(0, Math.min(1, n)); }
  function velocity(hist, key) {
    var a = hist[0], b = hist[hist.length - 1], dt = (b.t - a.t) / 1000;
    return dt > 0 ? (b[key] - a[key]) / dt : 0;
  }
  function pushHist(hist, entry) {
    hist.push(entry);
    while (hist.length > 2 && entry.t - hist[0].t > 100) hist.shift();
  }
  function project(x, v) { var dr = 0.99; return x + ((v / 1000) * dr) / (1 - dr); }

  /* ---------------- state ---------------- */

  var phys = { x: 0, v: 0, tx: 0, resp: 0.38, damp: 0.85, s: 1, sv: 0, ts: 1 };
  var sh = { o: 0, ov: 0, ot: 0, oResp: 0.42, oDamp: 0.86, dy: 0, dv: 0, dyT: 0, dResp: 0.3, dDamp: 0.8, ox: 0 };
  var drag = null;
  var sdrag = null;
  var raf = null;
  var last = 0;
  var lit = null;
  var shopOpen = false;
  var searching = false;
  var going = ''; // tab whose page is loading

  function w() { return row.clientWidth / 4; }

  function emitState() {
    root.classList.toggle('is-searching', searching);
    document.dispatchEvent(new CustomEvent('hl-tabbar:state', { detail: { searching: searching, shopOpen: shopOpen } }));
  }

  /* ---------------- painting ---------------- */

  function paintLit() {
    var k = lit != null ? TABS[lit] : shopOpen ? 'shop' : going || active;
    tabEls.forEach(function (el) { el.classList.toggle('is-lit', el.dataset.tab === k); });
    // A page with no tab of its own shows no pill until something is touched.
    pill.classList.toggle('is-shown', !!k);
  }

  function paintPill() {
    var p = phys;
    var lift = clamp01((p.s - 1) / 0.15);
    var stretch = Math.min(0.12, Math.abs(p.v) / 6000);
    pill.style.transform =
      'translateX(' + p.x + 'px) scale(' + p.s * (1 + stretch) + ', ' + p.s * (1 - stretch * 0.5) + ')';
    pill.style.background = 'rgba(255,255,255,' + (0.85 - 0.5 * lift) + ')';
    pill.style.boxShadow =
      '0 ' + (1 + 7 * lift) + 'px ' + (3 + 17 * lift) + 'px rgba(57,37,26,' + (0.12 + 0.06 * lift) + '), ' +
      'inset 0 1px 0 #FFFFFF, inset 0 0 0 ' + lift + 'px rgba(255,255,255,0.9), ' +
      'inset 0 -' + 4 * lift + 'px ' + 10 * lift + 'px rgba(255,255,255,' + 0.5 * lift + ')';
  }

  function paintSheet() {
    var q = sh, o = q.o, H = sheet.offsetHeight || 540;
    var vis = o > 0.002 || q.ot > 0;
    sheet.style.visibility = vis ? 'visible' : 'hidden';
    scrim.style.visibility = vis ? 'visible' : 'hidden';
    sheet.style.transformOrigin = q.ox + 'px 100%';
    sheet.style.transform =
      'translateY(' + ((1 - o) * 24 + q.dy) + 'px) scale(' + (0.18 + 0.82 * o) + ', ' + (0.12 + 0.88 * o) + ')';
    sheet.style.opacity = clamp01(o * 1.8);
    sheet.style.filter = o < 0.999 ? 'blur(' + Math.max(0, (1 - o) * 10) + 'px)' : 'none';
    scrim.style.opacity = clamp01(o) * 0.28 * (1 - Math.max(0, q.dy) / H);
    for (var i = 0; i < tiles.length; i++) {
      var a = clamp01((o - 0.3 - i * 0.04) / 0.4);
      tiles[i].style.opacity = a;
      tiles[i].style.transform = 'translateY(' + (1 - a) * 14 + 'px) scale(' + (0.96 + 0.04 * a) + ')';
    }
  }

  function kick() {
    if (!raf) {
      last = performance.now();
      raf = requestAnimationFrame(step);
    }
  }

  function step(now) {
    var p = phys, q = sh;
    var dt = Math.min(1 / 30, (now - last) / 1000);
    last = now;

    var r = spring(p.x, p.v, p.tx, p.resp, p.damp, dt); p.x = r[0]; p.v = r[1];
    r = spring(p.s, p.sv, p.ts, 0.25, 0.7, dt); p.s = r[0]; p.sv = r[1];
    r = spring(q.o, q.ov, q.ot, q.oResp, q.oDamp, dt); q.o = r[0]; q.ov = r[1];
    if (!sdrag) { r = spring(q.dy, q.dv, q.dyT, q.dResp, q.dDamp, dt); q.dy = r[0]; q.dv = r[1]; }

    var sheetSettled = !sdrag && Math.abs(q.o - q.ot) < 0.002 && Math.abs(q.ov) < 0.02 &&
      Math.abs(q.dy - q.dyT) < 0.3 && Math.abs(q.dv) < 5;
    if (sheetSettled) {
      q.o = q.ot; q.ov = 0; q.dy = q.dyT; q.dv = 0;
      if (q.ot === 0) q.dy = q.dyT = 0;
    }
    paintPill();
    paintSheet();

    var settled = sheetSettled && !drag && Math.abs(p.x - p.tx) < 0.3 && Math.abs(p.v) < 5 &&
      Math.abs(p.s - p.ts) < 0.002 && Math.abs(p.sv) < 0.02;
    if (settled) {
      p.x = p.tx; p.v = 0; p.s = p.ts;
      paintPill();
      raf = null;
      return;
    }
    raf = requestAnimationFrame(step);
  }

  function syncTo(i, instant) {
    var p = phys;
    p.tx = Math.max(0, i) * w();
    if (instant || reduced) { p.x = p.tx; p.v = 0; }
    kick();
  }

  /* ---------------- Shop sheet ---------------- */

  function setSheetA11y(open) {
    sheet.setAttribute('aria-hidden', String(!open));
    if (open) sheet.removeAttribute('inert'); else sheet.setAttribute('inert', '');
    var shopTab = root.querySelector('[data-tab="shop"]');
    if (shopTab) shopTab.setAttribute('aria-expanded', String(open));
  }

  function showSub(id) {
    root.classList.toggle('is-drilled', !!id);
    sheet.querySelectorAll('[data-tb-sub]').forEach(function (pane) {
      var on = pane.dataset.tbSub === id;
      pane.classList.toggle('is-current', on);
      if (on) { pane.removeAttribute('inert'); pane.scrollTop = 0; } else pane.setAttribute('inert', '');
    });
    var rootPane = sheet.querySelector('[data-tb-root]');
    if (id) rootPane.setAttribute('inert', ''); else rootPane.removeAttribute('inert');
  }

  function openShop() {
    if (searching) closeSearch();
    var q = sh;
    var rr = row.getBoundingClientRect(), sr = sheet.getBoundingClientRect();
    // Grow out of (and shrink back into) the centre of the Shop tab.
    q.ox = rr.left + 1.5 * w() - sr.left;
    q.ot = 1; q.oResp = 0.42; q.oDamp = 0.86; q.dy = q.dyT = 0; q.dv = 0;
    if (reduced) { q.o = 1; q.ov = 0; }
    showSub(null);
    var paneRoot = sheet.querySelector('[data-tb-root]');
    if (paneRoot) paneRoot.scrollTop = 0;
    shopOpen = true;
    setSheetA11y(true);
    phys.resp = 0.38; phys.damp = 0.85;
    syncTo(1);
    paintLit();
    emitState();
    kick();
  }

  function closeShop(keepPill) {
    if (!shopOpen) return;
    var q = sh, p = phys;
    q.ot = 0; q.oResp = 0.32; q.oDamp = 1;
    if (reduced) { q.o = 0; q.ov = 0; }
    if (!keepPill) {
      p.resp = 0.38; p.damp = 0.85;
      if (activeIndex >= 0) syncTo(activeIndex);
    }
    shopOpen = false;
    setSheetA11y(false);
    paintLit();
    emitState();
    kick();
  }

  sheet.addEventListener('click', function (e) {
    var drill = e.target.closest('[data-tb-drill]');
    if (drill) { showSub(drill.dataset.tbDrill); return; }
    if (e.target.closest('[data-tb-subback]')) { showSub(null); return; }
    if (e.target.closest('[data-tb-sheet-close]')) closeShop();
  });
  scrim.addEventListener('click', function () { closeShop(); });

  sheetHead.addEventListener('pointerdown', function (e) {
    if (e.button > 0 || e.target.closest('button')) return;
    sheetHead.setPointerCapture(e.pointerId);
    sdrag = { sy: e.clientY, base: sh.dy, hist: [{ y: e.clientY, t: performance.now() }] };
  });
  sheetHead.addEventListener('pointermove', function (e) {
    if (!sdrag) return;
    var H = sheet.offsetHeight;
    pushHist(sdrag.hist, { y: e.clientY, t: performance.now() });
    var raw = sdrag.base + e.clientY - sdrag.sy;
    sh.dy = raw >= 0 ? raw : -rubber(-raw, H);
    sh.dv = 0;
    kick();
  });
  function sheetUp() {
    var d = sdrag;
    if (!d) return;
    sdrag = null;
    var q = sh, H = sheet.offsetHeight;
    var v = velocity(d.hist, 'y');
    q.dv = v;
    if (project(q.dy, v) > H * 0.35) {
      q.dyT = H * 0.5; q.dResp = 0.35; q.dDamp = 1;
      closeShop();
    } else {
      q.dyT = 0; q.dResp = 0.3; q.dDamp = 0.8;
      kick();
    }
  }
  sheetHead.addEventListener('pointerup', sheetUp);
  sheetHead.addEventListener('pointercancel', sheetUp);

  /* ---------------- tabs ---------------- */

  function navigate(k) {
    var el = root.querySelector('[data-tab="' + k + '"]');
    var href = el && el.dataset.href;
    if (!href) return;
    if (k === active) {
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
      return;
    }
    going = k;
    paintLit();
    // Let the pill land before the page changes.
    setTimeout(function () { window.location.href = href; }, reduced ? 0 : 220);
  }

  function select(i, keepVel) {
    var p = phys, k = TABS[i];
    if (!keepVel) { p.resp = 0.38; p.damp = 0.85; }
    p.tx = i * w();
    if (reduced) { p.x = p.tx; p.v = 0; }
    kick();
    if (k === 'shop') {
      if (shopOpen && !keepVel) closeShop(); else openShop();
      return;
    }
    if (shopOpen) closeShop(true);
    navigate(k);
  }

  function localX(e) { return e.clientX - row.getBoundingClientRect().left; }

  row.addEventListener('pointerdown', function (e) {
    if (searching || e.button > 0) return;
    row.setPointerCapture(e.pointerId);
    var px = localX(e), p = phys, tw = w();
    var onPill = pill.classList.contains('is-shown') && px >= p.x && px <= p.x + tw;
    drag = { sx: e.clientX, moved: false, grab: onPill ? px - p.x : tw / 2, hist: [{ x: px, t: performance.now() }] };
    p.ts = reduced ? 1 : 1.15;
    kick();
  });

  row.addEventListener('pointermove', function (e) {
    var d = drag;
    if (!d) return;
    var tw = w(), px = localX(e), p = phys, max = 3 * tw;
    if (!d.moved && Math.abs(e.clientX - d.sx) > 6) {
      d.moved = true;
      root.classList.add('is-dragging');
      pill.classList.add('is-shown');
    }
    pushHist(d.hist, { x: px, t: performance.now() });
    if (!d.moved) return;
    var raw = px - d.grab;
    p.tx = raw < 0 ? -rubber(-raw, tw) : raw > max ? max + rubber(raw - max, tw) : raw;
    p.resp = 0.12; p.damp = 1;
    if (reduced) p.x = p.tx;
    var l = Math.round(Math.max(0, Math.min(max, raw)) / tw);
    if (l !== lit) { lit = l; paintLit(); }
    kick();
  });

  function rowUp(e) {
    var d = drag;
    if (!d) return;
    drag = null;
    var tw = w(), p = phys;
    p.ts = 1;
    root.classList.remove('is-dragging');
    lit = null;
    if (e.type === 'pointercancel') {
      syncTo(shopOpen ? 1 : activeIndex);
      paintLit();
      kick();
      return;
    }
    if (!d.moved) {
      select(Math.max(0, Math.min(3, Math.floor(localX(e) / tw))));
    } else {
      var v = velocity(d.hist, 'x');
      p.v = reduced ? 0 : v; p.resp = 0.4; p.damp = 0.8;
      select(Math.max(0, Math.min(3, Math.round(project(p.x, v) / tw))), true);
    }
    paintLit();
  }
  row.addEventListener('pointerup', rowUp);
  row.addEventListener('pointercancel', rowUp);

  // Keyboard: Enter / Space fire a click with detail 0. Pointer taps are
  // already handled by pointerup, so their clicks (detail ≥ 1) are ignored.
  tabEls.forEach(function (el, i) {
    el.addEventListener('click', function (e) {
      if (e.detail !== 0) return;
      select(i);
    });
  });

  /* ---------------- search ---------------- */

  var suggestBox = $('[data-tb-suggest]');
  var resultsBox = $('[data-tb-results]');
  var resultsLabel = $('[data-tb-results-label]');
  var rlist = $('[data-tb-rlist]');
  var noResults = $('[data-tb-noresults]');
  var recentBox = $('[data-tb-recent]');
  var clearBtn = $('[data-tb-clear]');
  var backBtn = $('[data-tb-back]');
  var searchUrl = root.dataset.suggestUrl || '/search/suggest';
  var debounce = null;

  function readRecent() {
    try {
      var list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(list) && list.length ? list.slice(0, 6) : RECENT_DEFAULT;
    } catch (e) {
      return RECENT_DEFAULT;
    }
  }
  function saveRecent(q) {
    q = (q || '').trim();
    if (!q) return;
    try {
      var list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      if (!Array.isArray(list)) list = [];
      list = [q].concat(list.filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); })).slice(0, 6);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list));
    } catch (e) { /* private mode: recent searches just don't persist */ }
  }
  function renderRecent() {
    recentBox.textContent = '';
    readRecent().forEach(function (label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hl-tb__chip';
      b.textContent = label;
      b.addEventListener('click', function () { setQuery(label); input.focus(); });
      recentBox.appendChild(b);
    });
  }

  var moneyFmt;
  try {
    moneyFmt = new Intl.NumberFormat('en-AU', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD' });
  } catch (e) { moneyFmt = null; }
  function money(amount) {
    var n = Number(amount);
    if (!isFinite(n)) return '';
    var s = moneyFmt ? moneyFmt.format(n) : '$' + n.toFixed(2);
    return s.replace(/\.00$/, '');
  }

  function showView(view, q) {
    suggestBox.hidden = view !== 'suggest';
    resultsBox.hidden = view !== 'results';
    noResults.hidden = view !== 'none';
    if (view === 'none') noResults.textContent = 'Nothing found for “' + q + '”. Try a room or a material.';
  }

  // Shortcut rows (rubbish removal, delivery, warranty, store pages…) and
  // the spelling line come from the shared engine, assets/hl-search-brain.js.
  var SHORT_ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';

  function shortRow(it, q) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.className = 'hl-tb__result hl-tb__short';
    a.href = it.url;
    a.addEventListener('click', function () { saveRecent(q); });
    var ic = document.createElement('span');
    ic.className = 'hl-tb__short-ic';
    ic.innerHTML = SHORT_ICON;
    var text = document.createElement('span');
    text.className = 'hl-tb__result-text';
    var name = document.createElement('span');
    name.className = 'hl-tb__result-name';
    name.textContent = it.title;
    text.appendChild(name);
    if (it.description) {
      var d = document.createElement('span');
      d.className = 'hl-tb__result-cat';
      d.textContent = it.description;
      text.appendChild(d);
    }
    a.appendChild(ic);
    a.appendChild(text);
    li.appendChild(a);
    return li;
  }

  function productRow(p, q) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.className = 'hl-tb__result';
    a.href = p.url;
    a.addEventListener('click', function () { saveRecent(q); });
    var img = document.createElement(p.image ? 'img' : 'span');
    img.className = 'hl-tb__result-img';
    if (p.image) {
      img.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      img.alt = '';
      img.loading = 'lazy';
      img.width = 56;
      img.height = 56;
    }
    var text = document.createElement('span');
    text.className = 'hl-tb__result-text';
    var name = document.createElement('span');
    name.className = 'hl-tb__result-name';
    name.textContent = p.title;
    text.appendChild(name);
    var catText = p.type || p.vendor || '';
    if (catText) {
      var cat = document.createElement('span');
      cat.className = 'hl-tb__result-cat';
      cat.textContent = catText;
      text.appendChild(cat);
    }
    var price = document.createElement('span');
    price.className = 'hl-tb__result-price';
    price.textContent = typeof p.price === 'string' && p.price.charAt(0) === '$' ? p.price : money(p.price);
    a.appendChild(img);
    a.appendChild(text);
    a.appendChild(price);
    li.appendChild(a);
    return li;
  }

  function renderResults(q, r) {
    var shorts = (r.intents || []).concat((r.pages || []).map(function (pg) {
      return { title: pg.title, url: pg.url, description: '' };
    })).slice(0, 4);
    var list = r.products || [];
    var oldNote = resultsBox.querySelector('.hl-tb__dym');
    if (oldNote) oldNote.remove();

    if (!list.length && !shorts.length) {
      // Nothing at all: say so, and still offer a way forward.
      var brain = window.HLSearchBrain;
      var fb = (brain && brain.fallback()) || { title: "Can't find it? Ask us", description: 'Tell us what you’re after and we’ll help you find it.', url: '/pages/contact' };
      rlist.textContent = '';
      rlist.appendChild(shortRow(fb, q));
      resultsLabel.textContent = 'Nothing found for “' + q + '”';
      showView('results');
      return;
    }

    rlist.textContent = '';
    shorts.forEach(function (it) { rlist.appendChild(shortRow(it, q)); });
    list.forEach(function (p) { rlist.appendChild(productRow(p, q)); });

    if (r.corrected && r.typo) {
      var note = document.createElement('p');
      note.className = 'hl-tb__dym';
      note.appendChild(document.createTextNode('Showing results for '));
      var b = document.createElement('b');
      b.textContent = r.corrected;
      note.appendChild(b);
      resultsBox.insertBefore(note, resultsLabel);
    }

    resultsLabel.textContent = list.length
      ? list.length + (list.length === 1 ? ' result' : ' results')
      : 'Shortcuts';
    showView('results');
  }

  function fetchResults(q) {
    var brain = window.HLSearchBrain;
    var token = (fetchResults.seq = (fetchResults.seq || 0) + 1);
    if (!brain) {
      showView('none', q);
      return;
    }
    brain.search(q, { suggestUrl: searchUrl, limit: 10, intents: 3 }).then(function (r) {
      if (token !== fetchResults.seq || input.value.trim() !== q) return;
      if (r) renderResults(q, r);
    }, function () {
      if (input.value.trim() === q) showView('none', q);
    });
  }

  function onQuery() {
    var q = input.value.trim();
    clearBtn.hidden = !input.value;
    clearTimeout(debounce);
    if (!q) {
      fetchResults.seq = (fetchResults.seq || 0) + 1;
      showView('suggest');
      return;
    }
    debounce = setTimeout(function () { fetchResults(q); }, 160);
  }

  function setQuery(v) {
    input.value = v;
    onQuery();
  }

  function openSearch() {
    if (searching) return;
    if (shopOpen) closeShop();
    searching = true;
    renderRecent();
    showView(input.value.trim() ? 'results' : 'suggest');
    overlay.setAttribute('aria-hidden', 'false');
    input.tabIndex = 0;
    backBtn.tabIndex = 0;
    emitState();
    setTimeout(function () { input.focus(); }, reduced ? 0 : 200);
  }

  function closeSearch() {
    if (!searching) return;
    searching = false;
    input.value = '';
    clearBtn.hidden = true;
    fetchResults.seq = (fetchResults.seq || 0) + 1;
    showView('suggest');
    overlay.setAttribute('aria-hidden', 'true');
    input.tabIndex = -1;
    backBtn.tabIndex = -1;
    input.blur();
    emitState();
  }

  $('[data-tb-search-open]').addEventListener('click', openSearch);
  backBtn.addEventListener('click', closeSearch);
  clearBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    setQuery('');
    input.focus();
  });
  input.addEventListener('input', onQuery);
  $('[data-tb-form]').addEventListener('submit', function (e) {
    if (!input.value.trim()) { e.preventDefault(); return; }
    saveRecent(input.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (searching) closeSearch();
    else if (shopOpen) closeShop();
  });

  /* ---------------- cart badge ---------------- */

  // Delivery and rubbish removal are cart lines too, but they're charges, not
  // pieces (see snippets/hl-cart-count.liquid). Both are set up as "doesn't
  // require shipping", which is how /cart.js lets us tell them apart.
  var SERVICE_HANDLES = ['delivery', 'rubbish-removal'];
  function countPieces(cart) {
    if (window.hlCartPieces) return window.hlCartPieces(cart);
    return (cart.items || []).reduce(function (n, it) {
      if (it.requires_shipping === false || SERVICE_HANDLES.indexOf(it.handle) > -1) return n;
      return n + it.quantity;
    }, 0);
  }

  var popT = null;
  function setBadge(n) {
    if (!badge) return;
    var prev = parseInt(badge.textContent, 10) || 0;
    badge.textContent = n;
    badge.hidden = n === 0;
    if (n !== prev && n > 0 && !reduced) {
      badge.classList.add('is-pop');
      clearTimeout(popT);
      popT = setTimeout(function () { badge.classList.remove('is-pop'); }, 160);
    }
  }

  function refreshBadge(cart) {
    if (cart && Array.isArray(cart.items) && cart.token) { setBadge(countPieces(cart)); return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setBadge(countPieces(c)); })
      .catch(function () {});
  }

  document.addEventListener('hl-cart:changed', function (e) { refreshBadge(e.detail && e.detail.cart); });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    // Back from a page we navigated to: the bar is restored mid-transition.
    going = '';
    closeShop();
    closeSearch();
    paintLit();
    onLayout();
    refreshBadge();
  });
  function hookPubSub() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // Product-form events carry the added line, not the whole cart, so
      // only a payload that looks like a full cart is used directly.
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { refreshBadge(ev && ev.cartData); });
      return true;
    }
    return false;
  }
  if (!hookPubSub()) document.addEventListener('DOMContentLoaded', hookPubSub);

  /* ---------------- wiring ---------------- */

  document.addEventListener('hl-tabbar:open-shop', function () { if (mq.matches) openShop(); });

  function onLayout() {
    if (drag) return;
    syncTo(shopOpen ? 1 : activeIndex, true);
  }
  window.addEventListener('resize', onLayout);
  if (mq.addEventListener) mq.addEventListener('change', function () {
    if (!mq.matches) { closeShop(); closeSearch(); }
    onLayout();
  });

  paintLit();
  onLayout();
  paintSheet();
})();
